/**
 * Convert hyphenated or space-separated string to title case (e.g. "flying-cloud" -> "Flying Cloud").
 */
export const toTitleCase = (str) => {
  if (str == null || typeof str !== 'string') return '';
  return str
    .replace(/-/g, ' ')
    .split(' ')
    .map(word => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ''))
    .join(' ');
};
